<template>
  <div v-if="visible" class="user-profile-overlay" @click="$emit('close')">
    <div class="user-profile-panel"  @click.stop style="display: flex; flex-direction: column; min-height: 100%;" id="myScroll">
        <!-- <h2>{{ user.personalInfo.firstName }}'s Profile</h2>
        <p>Email: {{ user.personalInfo.contactInfo.email }}</p> -->
        <div  style="flex-grow: 1;">
        <div class="profile-header" style="display: flex; align-items: center; margin-bottom: 20px;">
          <!-- Avatar -->
          <img
            src="../assets/avtar.png" 
            alt="User Avatar"
            style="width: 80px; height: 80px; border-radius: 50%; margin-right: 20px;"
          />
          
          <!-- User Info -->
          <div>
            <h5>{{ user.personalInfo.firstName | capitalizeFirst }} {{ user.personalInfo.lastName | capitalizeFirst }}</h5>
            <p class="text-gray-04 font-12 text-lowercase"> {{ user.personalInfo.contactInfo.email }}</p>
            <p class="text-gray-04 font-12"> {{ user.personalInfo.contactInfo.phoneNumber }}</p>
          </div>
        </div>
        <div class="resumeContainer">
          <div v-if="user.resume_url" class="resumeBox">
            <div class="font-12">{{ getResumeFileName(user?.resume_url) }}</div>
            <v-btn icon :loading="resumeDownloading" :disabled="resumeDownloading" @click="onResumeIconClick(user?.resume_url)">
                 <template v-slot:loader>
                   <v-progress-circular indeterminate size="20" width="2" color="primary"></v-progress-circular>
                 </template>
                 <img src="@/assets/view_1.svg" alt="Resume" style="width: 24px; height: 24px;" />
            </v-btn>
          </div>
          <div v-else>
            Resume Not Uploaded
          </div>
          
        </div>
        <div class="my-4 caption">
          <strong >Personal Details</strong>
        </div>
        
<div style="display: flex; justify-content: space-between; gap: 30px;" class="my-4">
  <!-- Left Column -->
  <div style="flex: 1; display: flex; flex-direction: column; gap: 15px; word-break: break-word;" class="font-12">
  
  <div>
    <p class="text-gray-04">DOB</p>
    <span v-if="user.personalInfo.dob">{{ formatDate(user.personalInfo.dob) }}</span>
    <span v-else>NA</span>
  </div>
  <div>
    <p class="text-gray-04">Source</p>
    <span v-if="user.personalInfo.source">{{ user.personalInfo.source }}</span>
    <span v-else>NA</span>
  </div>

  <div>
    <p class="text-gray-04">Country</p>
    <span>{{ user.personalInfo.addressInfo.countryName }}</span>
  </div>
  <div>
    <p class="text-gray-04">district</p>
    <span v-if="user.personalInfo.addressInfo.districtName">{{ user.personalInfo.addressInfo.districtName }}</span>
    <span v-else>NA</span>
  </div>
  <div>
    <p class="text-gray-04">Created On</p>
    <span>{{ formatDate(user.createdOn) }}</span>
  </div>
</div>

<!-- Right Column -->
<div style="flex: 1; display: flex; flex-direction: column; gap: 15px; word-break: break-word;" class="font-12">
  <div>
    <p class="text-gray-04">Gender</p>
    <span>{{ user.personalInfo.gender }}</span>
  </div>
  <div>
    <p class="text-gray-04">Pincode</p>
    <span>{{ user.personalInfo.addressInfo.pincode }}</span>
  </div>
  <div>
    <p class="text-gray-04">State</p>
    <span>{{ user.personalInfo.addressInfo.stateName }}</span>
  </div>
  <div>
    <p class="text-gray-04">City</p>
    <span>{{ user.personalInfo.addressInfo.cityName }}</span>
  </div>
  <div>
    <p class="text-gray-04">Last Updated On</p>
    <span>{{ formatDate(user.updatedOn) }}</span>
  </div>
  
</div>
</div>
<v-divider></v-divider>
<div class="my-4 caption">
  <strong >Job Details & Preferences </strong>
  <p class="mt-4 text-gray-04">Subject</p>
  <p class="mb-4" v-if="user.teachingInterests?.subjects">{{ user.teachingInterests?.subjects?.join(', ') }}</p>
  <p class="mb-4" v-else>NA</p>
  <p class="text-gray-04">Preferred Job Role</p>
  <p class="mb-4" v-if="user.teachingInterests?.jobRole?.HRIS_unique_role">{{user.teachingInterests?.jobRole?.HRIS_unique_role}}</p>
  <p class="mb-4" v-else>NA</p>
</div>
<div style="display: flex; justify-content: space-between; gap: 30px;" class="my-4">
  <!-- Left Column -->
  <div style="flex: 1; display: flex; flex-direction: column; gap: 15px; word-break: break-word;" class="caption">
    <div>
      <p class="text-gray-04">School Cities</p>
      <span v-if="user.teachingInterests?.schoolCities">
        {{ user.teachingInterests?.schoolCities?.map(city => city.description).join(", ") }}
      </span>
      <span v-else>NA</span>
    </div>
    <div>
      <p class="text-gray-04">Type Of Job</p>
      <span v-if="user.teachingInterests?.jobType">{{ user.teachingInterests?.jobType }}</span>
      <span v-else>NA</span>
    </div>
  </div>

  <!-- Right Column -->
  <div style="flex: 1; display: flex; flex-direction: column; gap: 15px; word-break: break-word;" class="caption">
    <div>
      <p class="text-gray-04">Preferred Location</p>
      <span v-if="user.teachingInterests?.schools">{{ user.teachingInterests?.schools }}</span>
      <span v-else>NA</span>
    </div>
    <div>
      <p class="text-gray-04">Department</p>
      <span v-if="user.teachingInterests?.department">{{ user.teachingInterests?.department }}</span>
      <span v-else>NA</span>
    </div>
  </div>
</div>

<v-divider></v-divider>
<div style="display: flex; justify-content: space-between; gap: 30px;" class="mt-4 caption">
  <div style="flex: 1; display: flex; flex-direction: column; gap: 15px; word-break: break-word;">
    <div>
      <p class="text-gray-04">Other Job Role</p>
      <span v-if="user.teachingInterests?.otherJob?.length">{{ user.teachingInterests?.otherJob?.join(',') }}</span>
      <span v-else>NA</span>
    </div>
  </div>

  <div style="flex: 1; display: flex; flex-direction: column; gap: 15px; word-break: break-word;">
    <div>
      <p class="text-gray-04">Other Location</p>
      <span v-if="user.teachingInterests?.otherlocation?.length">{{ user.teachingInterests?.otherlocation?.join(',') }}</span>
      <span v-else>NA</span>
    </div>
  </div>
</div>

</div>

        <!-- Add more fields here -->
  <div class="d-flex justify-end mb-0" style="margin-top: auto;">
    <v-btn
    class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
    rounded
    depressed
    v-bind="attrs"
    v-on="on"
    @click="$emit('close')"
    >Close</v-btn>          
  </div>
    </div>
    <v-snackbar v-model="resumeDownloadSnackbar" :timeout="3000">
      Downloaded {{ resumeDownloadedFileName }}
    </v-snackbar>
  </div>

</template>

<script>
export default {
  props: {
    user: Object
  },
  data() {
    return {
      resumeDownloading: false,
      resumeDownloadSnackbar: false,
      resumeDownloadedFileName: ''
    };
  },
  computed: {
    visible() {
      console.log('this.user',this.user)
      return !!this.user;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods:{
    openInNewWindow(url = null){
      if(url){
        window.open(url, '_blank');
      }
    },
    onResumeIconClick(url = null) {
      if (!url) return;
      if (this.isMobile) {
        this.downloadResume(url);
      } else {
        this.openInNewWindow(url);
      }
    },
    async downloadResume(url) {
      if (!url || this.resumeDownloading) return;
      const fileName = this.getResumeFileName(url);
      this.resumeDownloading = true;
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        this.resumeDownloadedFileName = fileName;
        this.resumeDownloadSnackbar = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.resumeDownloading = false;
      }
    },
    formatDate(dateString) {
      if (dateString === "NA" || !dateString) {
          return dateString;
      }
      return new Date(dateString).toLocaleString('en-IN', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      });
    },
    getResumeFileName(url) {
    if (!url) return '';
    const decoded = decodeURIComponent(url);
    const match = decoded.match(/-([^-\/?]+\.pdf)/i); 
    return match ? match[1] : 'Resume';
  },
  }
};
</script>

<style scoped>
.user-profile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.4); /* Semi-transparent background */
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
}

.user-profile-panel {
  width: 460px;
  background: white;
  height: 100%;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  padding: 20px;
  position: relative;
  animation: slideIn 0.3s ease-out;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 20px;
  background: none;
  border: none;
  cursor: pointer;
}
.resumeContainer{
  border: 1px solid var(--gray-03);
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 16px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);

}
.text-gray-04 {
  color: var(--gray);
}
.resumeBox {
  display: flex;
  justify-content:space-between;
  align-items: center;
}


</style>
